const statusStyles: Record<string, string> = {
  DRAFT: "bg-gray-100 text-gray-600",
  VALIDATED: "bg-blue-50 text-blue-700",
  SUBMITTED: "bg-blue-50 text-blue-700",
  AWAITING_RELEASE: "bg-purple-50 text-purple-700",
  PAYMENT_PENDING: "bg-blue-50 text-blue-700",
  PAID: "bg-green-50 text-green-700",
  ERROR: "bg-orange-50 text-orange-700",
}

// The tinted pill of the dashboard and the application cards
const tintedStyles: Record<string, string> = {
  DRAFT: "bg-gray-100 text-gray-700",
  VALIDATED: "bg-[#DBEAFE] text-[#1E40AF]",
  SUBMITTED: "bg-[#DBEAFE] text-[#1E40AF]",
  AWAITING_RELEASE: "bg-[#F3E8FF] text-[#6B21A8]",
  PAYMENT_PENDING: "bg-[#DBEAFE] text-[#1E40AF]",
  PAID: "bg-[#DCFCE7] text-[#166534]",
  ERROR: "bg-orange-50 text-orange-700",
}

const statusLabels: Record<string, string> = {
  AWAITING_RELEASE: "Awaiting release",
  PAYMENT_PENDING: "Pending for payment",
}

interface StatusBadgeProps {
  status: string
  /** The tinted pill used on the dashboard and the application cards */
  tinted?: boolean
}

export default function StatusBadge({ status, tinted = false }: StatusBadgeProps) {
  const label =
    statusLabels[status] || status.charAt(0) + status.slice(1).toLowerCase()

  if (tinted) {
    return (
      <span
        className={`inline-block whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${
          tintedStyles[status] ?? tintedStyles.DRAFT
        }`}
      >
        {label}
      </span>
    )
  }

  return (
    <span
      className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${
        statusStyles[status] ?? statusStyles.DRAFT
      }`}
    >
      {label}
    </span>
  )
}
